<template>
  <transition name="transition">
    <div
      class="transition-page-container"
      @mousewheel.prevent
      v-if="transition"
    >
      <div class="logo-container">
        <img
          src="@/assets/image/home-logo.png"
          alt=""
          class="animate__animated animate__fadeIn"
        />
        <div class="slogan animate__animated animate__fadeInLeft">
          做<span style="color: #0057ff">改变</span>的创造者、推动者
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      transition: false,
    };
  },
  mounted() {},
  methods: {
    show() {
      this.transition = true;
    },
    hide() {
      this.transition = false;
    },
  },
};
</script>

<style lang="scss" scoped>
// .transition-enter-active,
.transition-leave-active {
  transition: opacity 0.5s;
}
// .transition-enter,
.transition-leave-to {
  opacity: 0;
}
.transition-page-container {
  position: fixed;
  width: 100%;
  min-width: 1240px;
  height: 100%;
  top: 0;
  left: 0;
  background: url("../assets/image/main-background.png");
  background-size: (100%, 100%);
  z-index: 999999;
  display: flex;
  justify-content: center;
  align-items: center;
  .logo-container {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      height: 28px;
    }
    .slogan {
      margin-top: 40px;
      font-family: PingFangSC-Semibold;
      font-size: 60px;
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/transitionPage.vue